import React from 'react';
import { consumeApi, isNullOrEmpty, setLiteral } from "../../../js/helpers.js";
import { f7, Row, Col, Button, List, ListItem, Block } from 'framework7-react';
import moment from 'moment';
import NumberFormat from "react-number-format";
import { prop } from 'dom7';

export default class PaymentMethod extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            lsLiterales: props.lsLiterales,
            card: '',
            displayCard: '',
            displayExistingCard: false
        }
    }

    componentDidMount() {
        this.getDataBank();
    }

    render() {
        return (
            <Block>
                <Row className="aligner">
                    <Col width="80" >

                        <Row>
                            <Col className="labelPaymentMethod" width="100">
                                {setLiteral(this.state.lsLiterales, 102108)}
                            </Col>
                        </Row>
                        <Row>
                            <Col width="50" medium="50" small="60" xsmall="60">
                                <List>
                                    <ListItem radio
                                        defaultChecked={isNullOrEmpty(this.state.card) ? true : false}
                                        title={this.state.displayCard}
                                        className={isNullOrEmpty(this.state.card) ? 'hidden' : ''}
                                        name="card"
                                        onChange={(e) => this.setState({ displayExistingCard: true })}
                                    >
                                    </ListItem>
                                    <ListItem radio
                                        defaultChecked={!isNullOrEmpty(this.state.card) ? true : false}
                                        title={setLiteral(this.state.lsLiterales, 102109)}
                                        name="card"
                                        onChange={(e) => this.setState({ displayExistingCard: false })}
                                    >
                                    </ListItem>
                                </List>
                            </Col>
                            <Col width="50" medium="50" small="40" xsmall="40">
                                <div width="100" className="imgCards"></div>
                            </Col>
                        </Row>
                        <Row className="aligner">
                            <Col width="100" medium="30" small="100">

                            </Col>
                            <Col style={{ paddingTop: "25px" }} width="100" medium="15" small="100" className="textCenter">
                                <Button fill round
                                    onClick={this.showCard}
                                >
                                    {setLiteral(this.state.lsLiterales, 102107)}
                                </Button>
                            </Col>
                            <Col width="10"></Col>
                            <Col style={{ paddingTop: "25px" }} width="100" medium="15" small="100" className="textCenter">

                                <Button fill round
                                    onClick={this.cancelPayment}
                                >
                                    {setLiteral(this.state.lsLiterales, 102079)}
                                </Button>

                            </Col>
                            <Col width="100" medium="30" small="100">

                            </Col>
                        </Row>
                        <Row>
                            <Col width="100">
                                .
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Block >
        );
    }

    showCard = () => {
        const { handleshowCard } = this.props;
        handleshowCard(this.state.displayExistingCard);
    }

    cancelPayment = () => {
        const { cancelPayment, contract } = this.props
        cancelPayment(contract)
    }


    getDataBank = async () => {

        f7.dialog.preloader("");

        const mDataBank = '/core/Domiciliation/BankDataByContractCode/' + this.props.configDomain.id_empresa + "/" + this.props.contract.contractCode
        const dataBank = await consumeApi("GET", mDataBank, "");

        if (typeof (dataBank) == 'object') {
            var data = dataBank.find(data => data.clientId == this.props.user.clientId && data.contractId == this.props.contract.contractId);

            if (!data.domiType.includes("CLABE")) {
                const sValue = data.numCard;
                this.setState({
                    card: sValue,
                    displayCard: '********' + sValue.substring(sValue.length - 4, sValue.length),
                    displayExistingCard: true
                });
            }
        }
        f7.dialog.close();

    }
}